export default "__VITE_ASSET__$cEuaLkP__"